import React, { Component } from "react";
import Cookies from "universal-cookie";
import withAuth from "../../hoc/withAuth";
import { Link } from "react-router-dom";

import ButtonLogout from "../buttons/ButtonLogout";
import SelectBiro from "../selects/SelectBiro";

import { Col, Layout, Menu } from "antd";
import { HomeOutlined, FileSearchOutlined, AuditOutlined, FolderOpenOutlined, DatabaseOutlined } from "@ant-design/icons";

const { Header, Content, Sider } = Layout;
const { SubMenu } = Menu;

class MainLayout extends Component {
  cookies = new Cookies();

  constructor(props) {
    super(props);

    this.state = {
      username: "",
      activeCode: this.props.match.params.code_svb,
      listServiceBureau: {},
      accessMenu: [], // <-- Menyimpan akses menu
    };
  }

  componentDidMount = () => {
    let currentState = { ...this.state };

    const token = this.cookies.get("_bbn_tn");
    const username = this.cookies.get("_bbn_un");
    const listServiceBureau = this.cookies.get("_bbn_ls");
    const accessMenuRaw = this.cookies.get("_bbn_m");

    if (token) {
      currentState.username = atob(username);
      currentState.listServiceBureau = JSON.parse(atob(listServiceBureau));

      if (Array.isArray(accessMenuRaw)) {
        currentState.accessMenu = accessMenuRaw;
      } else {
        try {
          currentState.accessMenu = JSON.parse(accessMenuRaw);
        } catch (e) {
          currentState.accessMenu = [];
        }
      }
    }

    this.setState(currentState);
  };

  /**
   * Mengecek apakah user punya akses ke menu berdasarkan ID
   */
  hasAccessMenu = (id) => {
    return this.state.accessMenu.some((menu) => menu.id === id);
  };

  slugify = (text) => {
    return text.toLowerCase().replace(/[^a-z0-9]/g, ""); // Hanya huruf & angka
  };

  render() {
    const { username, activeCode, accessMenu } = this.state;
    const { defaultSelectedKeys, defaultOpenKeys, children } = this.props;

    return (
      <Layout style={{ minHeight: "100vh" }}>
        <Header className="bg-primary-custom d-flex justify-content-between" style={{ height: "50px", lineHeight: "normal", color: "#FFF", position: "sticky", top: 0, zIndex: 1, width: "100%", alignItems: "center", padding: 5 }}>
          <Col xs={{ span: 0 }} lg={{ span: 4 }} style={{ minWidth: 100, marginLeft: 5 }}>
            <strong>PORTAL&nbsp;BIRO&nbsp;JASA</strong>
          </Col>
          <Col>
            <Col>
              <SelectBiro value={activeCode} listServiceBureau={this.state.listServiceBureau} onChangeBiro={(newCode) => this.setState({ activeCode: newCode })} />
            </Col>
          </Col>
          {/* <Col>&nbsp;</Col> */}
          <Col style={{ minWidth: 100 }}>
            <span>Hi,&nbsp;{username}</span>
            &nbsp;&nbsp;
            <ButtonLogout />
          </Col>
        </Header>

        <Layout>
          <Sider theme="light" breakpoint="lg" collapsedWidth="0" width={250}>
            <Menu defaultSelectedKeys={defaultSelectedKeys} defaultOpenKeys={defaultOpenKeys} mode="inline" style={{ fontSize: "80%" }}>
              {/* Dashboard */}
              {accessMenu.includes(1) && (
                <Menu.Item key="1dashboard" icon={<HomeOutlined />}>
                  <Link to={`/${activeCode}/dashboard`}>Dashboard</Link>
                </Menu.Item>
              )}

              {/* Monitoring Data */}
              {accessMenu.some((id) => [2, 3, 4, 5, 6].includes(id)) && (
                <SubMenu key="2monitoringdata" title="Monitoring Data" icon={<FileSearchOutlined />}>
                  {accessMenu.includes(3) && (
                    <Menu.Item key="3monitoringorder">
                      <Link to={`/${activeCode}/monitoring/order`}>Monitoring Order</Link>
                    </Menu.Item>
                  )}
                  {accessMenu.includes(4) && (
                    <Menu.Item key="4monitoringprogresif">
                      <Link to={`/${activeCode}/monitoring/progresif`}>Monitoring Progresif</Link>
                    </Menu.Item>
                  )}
                  {accessMenu.includes(5) && (
                    <Menu.Item key="5monitoringdokumen">
                      <Link to={`/${activeCode}/monitoring/dokumen`}>Monitoring Dokumen</Link>
                    </Menu.Item>
                  )}
                  {accessMenu.includes(6) && (
                    <Menu.Item key="6monitoringsamsat">
                      <Link to={`/${activeCode}/monitoring/samsat`}>Monitoring Samsat</Link>
                    </Menu.Item>
                  )}
                </SubMenu>
              )}

              {/* Dokumen */}
              {accessMenu.some((id) => [7, 8, 9, 10, 11, 12, 13, 14, 26].includes(id)) && (
                <SubMenu key="7dokumen" title="Dokumen" icon={<FolderOpenOutlined />}>
                  {accessMenu.includes(8) && (accessMenu.includes(9) || accessMenu.includes(10) || accessMenu.includes(11)) && (
                    <SubMenu key="8notice" title="Notice">
                      {/* {accessMenu.includes(9) && (
                        <Menu.Item key="9uploadnotice">
                          <Link to={`/${activeCode}/dokumen/notice/upload`}>Upload Notice</Link>
                        </Menu.Item>
                      )}
                      {accessMenu.includes(26) && (
                        <Menu.Item key="26uploadnotice">
                          <Link to={`/${activeCode}/dokumen/notice/upload/v2`}>Upload Notice *New</Link>
                        </Menu.Item>
                      )} */}
                      {accessMenu.includes(10) && (
                        <Menu.Item key="10uploadmultinotice">
                          <Link to={`/${activeCode}/dokumen/notice/multi-upload`}>Upload Multi Notice</Link>
                        </Menu.Item>
                      )}
                      {accessMenu.includes(11) && (
                        <Menu.Item key="11logmultiupload">
                          <Link to={`/${activeCode}/dokumen/notice/multi-upload/log`}>Log Multi Upload</Link>
                        </Menu.Item>
                      )}
                    </SubMenu>
                  )}
                  {accessMenu.includes(12) && (
                    <Menu.Item key="12uploadstnk">
                      <Link to={`/${activeCode}/dokumen/stnk/upload`}>Upload STNK</Link>
                    </Menu.Item>
                  )}
                  {accessMenu.includes(13) && (
                    <Menu.Item key="13uploadbpkb">
                      <Link to={`/${activeCode}/dokumen/bpkb/upload`}>Upload BPKB</Link>
                    </Menu.Item>
                  )}
                  {accessMenu.includes(14) && (
                    <Menu.Item key="14updatenomordokumen">
                      <Link to={`/${activeCode}/dokumen/update/nomor-dokumen`}>Update Nomor Dokumen</Link>
                    </Menu.Item>
                  )}
                </SubMenu>
              )}

              {/* Pembayaran */}
              {accessMenu.some((id) => [15, 16, 17, 18, 19, 20, 21].includes(id)) && (
                <SubMenu key="15pembayaran" title="Pembayaran" icon={<AuditOutlined />}>
                  {accessMenu.includes(16) && (
                    <Menu.Item key="16uploadtagihannotice">
                      <Link to={`/${activeCode}/upload-tagihan/notice`}>Upload Tagihan Notice</Link>
                    </Menu.Item>
                  )}
                  {accessMenu.includes(17) && (
                    <Menu.Item key="17uploadtagihanjasa">
                      <Link to={`/${activeCode}/upload-tagihan/jasa`}>Upload Tagihan Jasa</Link>
                    </Menu.Item>
                  )}
                  {accessMenu.includes(18) && (
                    <Menu.Item key="18bayartagihannotice">
                      <Link to={`/${activeCode}/pembayaran/tagihan/notice`}>Bayar Tagihan Notice</Link>
                    </Menu.Item>
                  )}
                  {accessMenu.includes(19) && (
                    <Menu.Item key="19bayartagihanproses">
                      <Link to={`/${activeCode}/pembayaran/tagihan/process`}>Bayar Tagihan Proses</Link>
                    </Menu.Item>
                  )}
                  {accessMenu.includes(20) && (
                    <Menu.Item key="20bayartagihanpkb">
                      <Link to={`/${activeCode}/pembayaran/tagihan/pkb`}>Bayar Tagihan PKB</Link>
                    </Menu.Item>
                  )}
                  {accessMenu.includes(21) && (
                    <Menu.Item key="21updatestatustagihan">
                      <Link to={`/${activeCode}/update/status-tagihan`}>Update Status Tagihan</Link>
                    </Menu.Item>
                  )}
                </SubMenu>
              )}

              {/* Manajemen Internal */}
              {accessMenu.some((id) => [22, 23, 24, 25, 27].includes(id)) && (
                <SubMenu key="22manajemeninternal" title="Manajemen Internal" icon={<DatabaseOutlined />}>
                  {accessMenu.includes(23) && (accessMenu.includes(24) || accessMenu.includes(25) || accessMenu.includes(27)) && (
                    <SubMenu key="23pembayaranulang" title="Pembayaran Ulang">
                      {accessMenu.includes(24) && (
                        <Menu.Item key="24tagihannotice">
                          <Link to={`/${activeCode}/internal/pembayaran-ulang/tagihan/notice`}>Tagihan Notice</Link>
                        </Menu.Item>
                      )}
                      {accessMenu.includes(24) && (
                        <Menu.Item key="23pembayaranulang">
                          <Link to={`/${activeCode}/internal/pembayaran-ulang/tagihan/notice-new`}>New Tagihan Notice</Link>
                        </Menu.Item>
                      )}
                      {accessMenu.includes(25) && (
                        <Menu.Item key="25tagihanproses">
                          <Link to={`/${activeCode}/internal/pembayaran-ulang/tagihan/proses`}>Tagihan Proses</Link>
                        </Menu.Item>
                      )}
                    </SubMenu>
                  )}
                </SubMenu>
              )}
            </Menu>
          </Sider>

          <Content>
            <div>{children}</div>
          </Content>
        </Layout>
      </Layout>
    );
  }
}

export default withAuth(MainLayout);
